import { OrganizationLevel, OrganizationUnit } from '../models/unit.model';

export function buildCommunityHierarchy(units: OrganizationUnit[]): OrganizationUnit[] {
  return units.flatMap<OrganizationUnit>(unit => {
    if (unit.organizationLevelId === OrganizationLevel.Comunidad) {
      return [{ ...unit, children: undefined }];
    }
    const children = buildCommunityHierarchy(unit.children ?? []);
    return children.length ? [{ ...unit, children }] : [];
  }).sort((left, right) => left.name.localeCompare(right.name, 'es-AR', { numeric: true }));
}
